import type { AppShellBounds } from './AppShellContext.ts';
import { useMergedRef, useResizeObserver } from '@mantine/hooks';
import { useEffect, useRef } from 'react';
import { useAppShell } from './useAppShell.ts';

export function useAppShellBoundsWatcher({ side }: { side: keyof AppShellBounds }) {
  const { setAppShellBounds } = useAppShell();

  const [sizeRef, size] = useResizeObserver();
  const elementRef = useRef(null);
  const ref = useMergedRef(elementRef, sizeRef);

  useEffect(() => {
    const dimension = side === 'left' || side === 'right' ? size.width : size.height;

    setAppShellBounds(bounds => ({
      ...bounds,
      [side]: bounds[side] + dimension
    }));

    return () => {
      setAppShellBounds(bounds => ({
        ...bounds,
        [side]: bounds[side] - dimension
      }));
    };
  }, [setAppShellBounds, side, size.height, size.width]);

  return ref;
}
